import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as C}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const a=t("barbados",C`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5L24 4.5L24 20.5L0 20.5L0 4.5Z"
                fill="#00267F" />
            <path
                d="M8 4.5L16 4.5L16 20.5L8 20.5L8 4.5Z"
                fill="#FFC726" />
            <path
                d="M15.4644 10.2488C14.8102 10.3295 14.1366 10.6015 13.6756 10.9794C13.622 11.0315 13.9606 10.9224 13.9914 10.9191C14.2444 10.8588 13.9164 11.2009 13.8978 11.2905C13.6386 11.9463 13.4134 12.58 13.3299 13.3343C13.3299 13.3864 13.3196 13.4247 13.2888 13.4272L12.4228 13.3254V10.8962C12.6263 10.8922 12.9433 10.9344 13.1243 10.9818C12.541 10.5215 12.2685 9.92038 12.0012 9.34277C11.7337 9.92038 11.4611 10.5215 10.8781 10.9818C11.0591 10.9346 11.3758 10.8922 11.5796 10.8962V13.3254L10.7136 13.4272C10.6828 13.4248 10.6724 13.3864 10.6724 13.3343C10.5892 12.58 10.3638 11.9463 10.1046 11.2905C10.0862 11.2009 9.75795 10.8588 10.011 10.9191C10.0418 10.9224 10.3801 11.0315 10.3268 10.9794C9.86605 10.6015 9.19213 10.3293 8.538 10.2488C8.4805 10.2373 8.44646 10.2603 8.49798 10.3131C9.36602 11.3712 10.0924 12.6201 10.0862 14.1017C10.4236 14.1017 11.2413 13.9436 11.5796 13.9436L11.5796 15.6575H12.423L12.423 13.9436C12.7614 13.9436 13.5793 14.1017 13.9164 14.1017C13.9102 12.6199 14.6364 11.3712 15.5046 10.3131C15.5562 10.2601 15.5221 10.2373 15.4646 10.2488H15.4644Z"
                fill="black" />
        </svg>
    `),o=t("barbados_rounded",C`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19470_66569)">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <path
                    d="M0 0.5L24 0.5L24 24.5001L0 24.5001L0 0.5Z"
                    fill="#00267F" />
                <path
                    d="M7.3125 0.5L16.6876 0.5V24.5001L7.3125 24.5001L7.3125 0.5Z"
                    fill="#FFC726" />
                <path
                    d="M15.7793 9.39707C15.0654 9.50828 14.3301 9.88307 13.8271 10.404C13.7686 10.4758 14.1381 10.3254 14.1717 10.3209C14.4479 10.2378 14.0899 10.7092 14.0696 10.8327C13.7866 11.7364 13.5409 12.6098 13.4498 13.6493C13.4498 13.7211 13.4385 13.7738 13.4048 13.7773L12.4597 13.637V10.2892C12.6819 10.2837 13.0278 10.342 13.2253 10.4072C12.5887 9.77287 12.2912 8.94446 11.9995 8.14844C11.7076 8.94446 11.4101 9.77287 10.7738 10.4072C10.9713 10.3422 11.317 10.2837 11.5394 10.2892V13.637L10.5943 13.7773C10.5606 13.7741 10.5493 13.7211 10.5493 13.6493C10.4585 12.6098 10.2124 11.7364 9.92954 10.8327C9.90945 10.7092 9.55123 10.2378 9.82736 10.3209C9.861 10.3254 10.2303 10.4758 10.172 10.404C9.66921 9.88307 8.93369 9.50803 8.21975 9.39707C8.157 9.38126 8.11984 9.41289 8.17608 9.48569C9.12347 10.9439 9.91623 12.665 9.90945 14.7069C10.2777 14.7069 11.1701 14.489 11.5394 14.489L11.5394 16.851H12.4599L12.4599 14.489C12.8292 14.489 13.7219 14.7069 14.0899 14.7069C14.0831 12.6648 14.8756 10.9439 15.8233 9.48569C15.8795 9.41264 15.8423 9.38126 15.7796 9.39707H15.7793Z"
                    fill="black" />
            </g>
            <defs>
                <clipPath id="clip0_19470_66569">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{a as Barbados,o as BarbadosRounded};
